import { DataStore } from '@skinsoft/data-store';

export interface Institution {
    id: string
}

export class InstitutionDataStore extends DataStore<Institution> {

    public static getInstance() {
        if (!InstitutionDataStore.instance) {
            InstitutionDataStore.instance = new InstitutionDataStore();
        }

        return InstitutionDataStore.instance;
    }

    public static install(Vue) {
        Vue.prototype.$institutionDataStore = InstitutionDataStore.getInstance();
    }

    private static instance: InstitutionDataStore = null as any;

    constructor() {
        super('/institution');
    }
}